



























import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import UserItem from "./Item.vue";
import { UserDto } from "@/store/users/user.interface";
import User from "@/store/users";
import SearchBar from "./SearchBar.vue";

@Component({
  components: {
    "user-item": UserItem,
    "search-bar": SearchBar
  }
})
export default class AppUserItem extends Vue {
  page: number = 1;
  data: UserDto[] = [];
  query: string = "";
  async infiniteHandler($state: any) {
    this.search($state);
  }

  async search($state: any) {
    try {
      const res = await User.api().fetch({
        params: {
          page: this.page,
          keywords: this.query
        }
      });

      const users = res.response.data.data;

      if (users.length) {
        this.data.push(...users);
        this.page += 1;
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    } catch (error) {}
  }

  async onSearch(query: string) {
    this.page = 1;
    this.data = [];
    this.query = query;
    this.search(null);
  }

  async goTo(item: UserDto) {
    this.$router.push("/users/" + item.id);
  }
}
